module.exports = __webpack_public_path__ + "static/media/yellow-red.7300b131.png";